module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/therussian_introduction#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/therussian_foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/therussian_authorsnote#authorsnote"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/therussian_thehistoryof01#thehistoryof01"
    }
  }, [_vm._v("The History of the Russian Officer Corps: An Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/therussian_thebiographies#thebiographies"
    }
  }, [_vm._v("The Biographies")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/therussian_bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b9113e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_toc.vue
// module id = 84
// module chunks = 0